import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import helpers from '../util/helpers';
import * as constants from '../util/constants';
import GlobalEatDrinkPostSkeleton from '../components/GlobalEatDrinkPostSkeleton/GlobalEatDrinkPostSkeleton';
//import GlobalEatDrinkPostSkeleton from '../components/GlobalEatDrinkPostSkeleton/GlobalEatDrinkPostSkeleton';

class AppGlobalEatAndDrink extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      allEatAndDrinks: [],
      allCategories: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.category = '';
    this.location = '';
    this.search = '';

    const category = helpers.getParameterByName('category');
    if (category != null && category.length) {
      this.category = category;
    }

    const location = helpers.getParameterByName('location');
    if (location != null && location.length) {
      this.location = location;
    }

    this.loadGlobalEatDrinkPosts = this.loadGlobalEatDrinkPosts.bind(this);
    this.loadMoreGlobalEatDrinkPosts = this.loadMoreGlobalEatDrinkPosts.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    this.loadGlobalEatDrinkPosts(true);

    $(document).on(constants.EVENT_EAT_DRINK_CATEGORY_FILTER_CHANGED, (e, category) => {
      if (this.category !== category) {
        this.category = category;
        this.loadGlobalEatDrinkPosts();
      }
    });

    $(document).on(constants.EVENT_EAT_DRINK_LOCATION_FILTER_CHANGED, (e, location) => {
      if (this.location !== location) {
        this.location = location;
        this.loadGlobalEatDrinkPosts();
      }
    });
  }

  loadGlobalEatDrinkPosts() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_GLOBAL_EAT_DRINK_POSTS,
      'category': this.category,
      'location': this.location,
      'offset': 0,
    };

    // Send request
    axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const postsCount = response.data['posts_count'];
          const posts = [...response.data['posts']];

          if (postsCount > 0) {
            this.setState({
              loading: false,
              allEatAndDrinks: [...posts],
              loadMoreLoading: false,
              loadedAll: postsCount == posts.length,
            });
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreGlobalEatDrinkPosts() {
    const {
      allEatAndDrinks,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_GLOBAL_EAT_DRINK_POSTS,
        'category': this.category,
        'location': this.location,
        'search': this.search,
        'offset': allEatAndDrinks.length,
      };

      // Send request
      axios.post(window.Ode['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const postsCount = response.data['posts_count'];
            const posts = [
              ...allEatAndDrinks,
              ...response.data['posts'],
            ];

            if (postsCount > 0) {
              this.setState({
                loading: false,
                allEatAndDrinks: [...posts],
                loadMoreLoading: false,
                loadedAll: postsCount == posts.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  render() {
    const {
      loading,
      allEatAndDrinks,
      loadMoreLoading,
      loadedAll,
    } = this.state;
    return (
      <React.Fragment>
        {
          !loading && allEatAndDrinks.length === 0 && (
            <h3 className="text-center">No articles found</h3>
          )
        }
        <div className="items-container">
          {
            !loading && allEatAndDrinks.length > 0 && (
              allEatAndDrinks.map((post, i) => {
                return (
                  <React.Fragment key={i}>
                    <a href={post['link']}  className="item">
                      <div className="item-image">
                        {post.thumbnail_image && <img src={post.thumbnail_image} alt="Restaurant"/>}
                      </div>
                      <div className="item-content">
                        <div className="item-taxonomy">
                          <span className="item-brand">{post.hotel_name}</span>
                          <span className="item-category">{post.category}</span>
                        </div>
                        <h3 className="item-title">{post.title}</h3>
                        <div className="item-description text-ellipsis eat-drink-description" dangerouslySetInnerHTML={{__html: post.description}} />
                        <div className="item-button">
                          <span className="btn">View details</span>
                        </div>
                      </div>
                    </a>
                  </React.Fragment>
                );
              })
            )
          }
        </div>
        {
          (loading || loadMoreLoading) && (
            <GlobalEatDrinkPostSkeleton />
          )
        }
        {
          (loading || loadMoreLoading || allEatAndDrinks.length > 0) && (
            <div className="row loadMoreButton">
              <button className="btn btn-white btn-underline load-more-btn" disabled={loading || loadMoreLoading || loadedAll} onClick={this.loadMoreGlobalEatDrinkPosts}>
                {!loadedAll ? 'Load More' : 'That\'s All'}
              </button>
            </div>
          )
        }
      </React.Fragment>
    );
  }
}

export default {
  init() {
    // init here
  },
  finalize() {
    // finalize here
    // Global QT Life posts
    const globalEatDrinkPostsWrapper = $('.global-eat-and-drink-content .eat-drink-list');
    if (globalEatDrinkPostsWrapper.length) {
      ReactDOM.render(<AppGlobalEatAndDrink />, globalEatDrinkPostsWrapper[0]);
    }

    const eatDrinkCategoriesFilter = $('#hotels-eat-drink-type');
    if (eatDrinkCategoriesFilter.length) {
      const filterItems = eatDrinkCategoriesFilter.find('.filter-item');
      eatDrinkCategoriesFilter.on('select2:select', function(e) {
        e.preventDefault();
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        filterItems.removeClass('active');
        _this.addClass('active');

        if (selectedVal !== '') {
          params['category'] = selectedVal;
        } else {
          delete params['category'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_EAT_DRINK_CATEGORY_FILTER_CHANGED, [selectedVal]);
      });
    }

    const eatDrinkHotelsFilter = $('#location-eat-drink');
    if (eatDrinkHotelsFilter.length) {
      const filterItems = eatDrinkCategoriesFilter.find('.filter-item');
      eatDrinkHotelsFilter.on('select2:select', function(e) {
        e.preventDefault();
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        filterItems.removeClass('active');
        _this.addClass('active');

        if (selectedVal !== '') {
          params['blog_id'] = selectedVal;
        } else {
          delete params['blog_id'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_EAT_DRINK_LOCATION_FILTER_CHANGED, [selectedVal]);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalEatAndDrink.js